export const WB_STICKER_SIZE_MM = {
  width: 58,
  height: 40,
};

export const WB_STICKER_POPUP_SIZE = {
  width: 820,
  height: 560,
};

export const WB_STICKER_POPUP_FEATURES = `width=${WB_STICKER_POPUP_SIZE.width},height=${WB_STICKER_POPUP_SIZE.height},resizable=yes,scrollbars=yes`;
